<template>
  <div class="query-container">
    <!-- 搜索区域 -->
    <div class="search-box">
      <div class="search-item">
        <span class="search-label">应聘者姓名</span>
        <el-input
          v-model="formData.ijaName"
          placeholder="请输入"
          size="small"
          clearable
          @keyup.enter.native="handleSearch"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="search-label">手机号码</span>
        <el-input
          v-model="formData.ijaPhone"
          placeholder="请输入"
          size="small"
          clearable
          @keyup.enter.native="handleSearch"
        ></el-input>
      </div>
      <div class="search-actions">
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="result-box" v-loading="loading">
      <div v-if="!hasSearched" class="empty-hint">
        <span>请输入应聘者姓名或手机号码进行查询</span>
      </div>
      <div v-else-if="tableData.length === 0" class="empty-hint">
        <span>未查询到匹配的应聘者</span>
      </div>
      <div v-else class="data-list">
        <div class="data-item" v-for="(item, index) in tableData" :key="index">
          <div class="item-row">
            <span class="label">应聘者姓名：</span>
            <span class="value">{{ item.ijaName || '-' }}</span>
          </div>
          <div class="item-row">
            <span class="label">初试反馈：</span>
            <span class="value">{{ item.ijaFeedbackFirst || '-' }}</span>
          </div>
          <div class="item-row">
            <span class="label">跟进反馈：</span>
            <span class="value feedback-content">{{ item.ijaFeedbackFollow || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIvJobApplicantListSearch } from '../../api/api'

export default {
  name: 'ApplicantQuery',
  data () {
    return {
      loading: false,
      tableData: [],
      hasSearched: false,
      formData: {
        ijaName: '',
        ijaPhone: '',
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    async getList () {
      if (!this.formData.ijaName && !this.formData.ijaPhone) {
        this.$message.warning('请输入应聘者姓名或手机号码')
        return
      }
      this.loading = true
      try {
        const res = await getIvJobApplicantListSearch(this.formData)
        if (res.status === 200) {
          this.tableData = Array.isArray(res.data) ? res.data : []
          this.hasSearched = true
        } else {
          this.tableData = []
          this.hasSearched = true
          this.$message.warning(res.msg || '查询失败')
        }
      } catch (error) {
        this.tableData = []
        this.hasSearched = true
        console.error('查询失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleSearch () {
      this.formData.currentPage = 1
      this.getList()
    },
    handleReset () {
      this.formData = {
        ijaName: '',
        ijaPhone: '',
        currentPage: 1,
        pageSize: 10
      }
      this.tableData = []
      this.hasSearched = false
    }
  }
}
</script>

<style scoped>
.query-container {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
}

.search-box {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: #f5f7fa;
  border-radius: 8px;
}

.search-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.search-item .el-input {
  width: 180px;
}

.search-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.search-actions {
  display: flex;
  gap: 10px;
}

.result-box {
  background: #fff;
  border-radius: 8px;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.empty-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
  font-size: 14px;
}

.data-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.data-item {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 15px 20px;
  transition: box-shadow 0.3s;
}

.data-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.item-row {
  line-height: 1.8;
}

.label {
  color: #666;
  font-weight: 500;
}

.value {
  color: #333;
}

.feedback-content {
  display: block;
  margin-top: 5px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
